import EyeOff from './EyeOff';

export default EyeOff;
